export const environment = {
  production: false,
  config: {
    endpoints: {
      API: ''
    },
    shareQuoteEmailSubject: ''
  }
};
